<template>
    <div class="frmfeltoltottdokumentumok_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>


        <div class="frmfeltoltottdokumentumok_cont" v-show="(InitDone)&&(LIST.length>0)">
            <div v-for="(item, index) in LIST" :key="index" class="frmfeltoltottdokumentumok_item">
                <div class="frmfeltoltottdokumentumok_item_azonosito">{{item.Azonosito}}</div>
                <div class="frmfeltoltottdokumentumok_item_createdate">{{item.CreateDate}}</div>

                <div class="frmfeltoltottdokumentumok_item_tipusnev">{{item.TipusNev}}</div>
                <div class="frmfeltoltottdokumentumok_item_statusznev" v-show="item.StatuszNev!=''"><i class="fal fa-cog" style="margin-right:8px;"></i>{{item.StatuszNev}}</div>

                <div class="frmfeltoltottdokumentumok_item_megjegyzes" v-show="item.Megjegyzes!=''">
                    Megjegyzés: {{item.Megjegyzes}}
                </div>

                <div class="frmfeltoltottdokumentumok_item_filecont">
                    <div v-for="(fitem, findex) in FILES" :key="findex" class="frmfeltoltottdokumentumok_fileitem" v-show="fitem.FejID==item.id"
                    @click="DisplayFile(findex)">
                       <i class="fal fa-file" style="margin-right:8px;"></i>{{fitem.FajlNeve}} ({{fitem.FajlMeret}})
                    </div>
                </div>

            </div>
        </div>

        <div class="frmfeltoltottdokumentumok_cont" v-show="(InitDone)&&(LIST.length==0)" v-html="infotext_nincs_rekord">

        </div>



    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'

export default {
  name: 'frmfeltoltottdokumentumok',
  components: {
      GrcDB,
      GrcDialog,
      GrcDocDisplayer
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmFeltoltottDokumentumok_",

          InitDone:false,  
          LIST:[],
          FILES:[],

          infotext_nincs_rekord:"",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmFeltoltottDokumentumok", pCompName);
    },

    SetLang()
    {
        this.infotext_nincs_rekord = this.GetTextBookItem("infotext_nincs_rekord");
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },


    async DisplayFile(pIndex)
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]",
            iFileID:this.FILES[pIndex].id,
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "GetDocData", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var docb64 = Q.RESULT[0].FajlAdat;
        var docfn = Q.RESULT[0].FajlNev;
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi


        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }

    },


      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.LIST = Q.LIST;
        this.FILES = Q.FILES;

        this.InitDone = true;

      },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },


    async ShowError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


